import * as React from "react"
const FeedsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
  >
    <g
      stroke="#B6B9C7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="m12 4 8 5.2v5.6L12 20l-8-5.2V9.2L12 4v0Z" clipRule="evenodd" />
      <path d="M12 20v-5.2M20 9.2l-8 5.6-8-5.6" />
      <path d="m4 14.8 8-5.6 8 5.6M12 4v5.2" />
    </g>
  </svg>
)
export default FeedsIcon
